import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import ReactDOM from 'react-dom';
import AntCondition from '../../utils/AntCondition';
import AntLocalization from '../../utils/AntLocalization';
import AntAuth from '../../utils/AntAuth';
import AntAPI from '../../utils/AntAPI';
import { AntGlobal } from '../../utils/AntContext';
import AntBadgeStore from '../../utils/AntBadgeStore';
import cs from '../../utils/const.js';
import { FaLocationDot } from 'react-icons/fa6';
import './index.scss';
import { useLocation } from 'react-router-dom';

var STORAGE_KEY = 'ant_nav_v2_module';

// ─── Default SVG icons for items without icon ──────────────────
// Key = substring match against item path or text (lowercase)
var ITEM_ICON_MAP = {
    // AR
    'order': 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
    'issue': 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
    'shipment': 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
    'delivery': 'M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0',
    'credit': 'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z',
    'invoice': 'M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z',
    'payment': 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z',
    'return': 'M3 10h10a5 5 0 015 5v6M3 10l6-6M3 10l6 6',
    'receive': 'M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4 0v8m0 0l3-3m-3 3L9 9',
    'price': 'M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z',
    'promotion': 'M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7',
    'catalogue': 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
    'appointment': 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
    'customer': 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
    'lead': 'M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z',
    'inventory': 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
    'warehouse': 'M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z',
    'transfer': 'M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4',
    'adjust': 'M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4',
    'counting': 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01',
    'purchase': 'M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z',
    'supply': 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
    'manufactur': 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z',
    'cash': 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z',
    'journal': 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
    'account': 'M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z',
    'tax': 'M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z',
    'asset': 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
    'depreciat': 'M13 17h8m0 0V9m0 8l-8-8-4 4-6-6',
    'salary': 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    'attendance': 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
    'report': 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
    'setting': 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z',
    'permission': 'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z',
    'user': 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z',
    'deploy': 'M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12',
    'project': 'M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z',
    'balance': 'M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3',
    'reconcil': 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
    'budget': 'M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4',
    'expense': 'M19 14l-7 7m0 0l-7-7m7 7V3',
    'revenue': 'M5 10l7-7m0 0l7 7m-7-7v18',
    'kitchen': 'M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z',
    'serve': 'M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z',
    'franchise': 'M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z',
    'b2b': 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
    'serial': 'M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4',
    'bom': 'M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z',
    'location': 'M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z',
    'event': 'M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z',
    'ticket': 'M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z',
    'commission': 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    'dashboard': 'M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z',
    'service': 'M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z',
    'document': 'M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z',
    'meeting': 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z',
    'okr': 'M13 10V3L4 14h7v7l9-11h-7z',
    'approval': 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
    'ai': 'M13 10V3L4 14h7v7l9-11h-7z',
    'tool': 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z',
    'assembly': 'M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6z',
    'import': 'M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4',
    'valuation': 'M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z',
    'period': 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
    'shopee': 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
    'tiktok': 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
    'tiki': 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
    'amazon': 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
    'deposit': 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    'cost': 'M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z',
    'exchange': 'M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4',
    'rental': 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
    'booking': 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
    'vehicle': 'M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0',
    // Vietnamese keywords
    'đơn hàng': 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
    'đề nghị': 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
    'phiếu chi': 'M19 14l-7 7m0 0l-7-7m7 7V3',
    'phiếu thu': 'M5 10l7-7m0 0l7 7m-7-7v18',
    'phiếu lương': 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    'chuyển tiền': 'M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4',
    'điều chỉnh': 'M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4',
    'số dư': 'M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3',
    'đối soát': 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
    'sổ quỹ': 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
    'dòng tiền': 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6',
    'ghi sổ': 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
    'phiếu kế toán': 'M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z',
    'nhật ký': 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
    'xác định': 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
    'đóng kỳ': 'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z',
    'cân đối': 'M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3',
    'sổ cái': 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
    'công nợ': 'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z',
    'hóa đơn': 'M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z',
    'bảng kê': 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01',
    'chờ xuất': 'M12 19l9 2-9-18-9 18 9-2zm0 0v-8',
    'chờ nhận': 'M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4 0v8m0 0l3-3m-3 3L9 9',
    'xuất kho': 'M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1',
    'nhập kho': 'M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1',
    'chuyển kho': 'M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4',
    'kiểm kho': 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
    'vị trí kho': 'M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z',
    'nhập xuất tồn': 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
    'giá vốn': 'M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z',
    'lắp ráp': 'M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6z',
    'phân rã': 'M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z',
    'mã lô': 'M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4',
    'nhu cầu': 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
    'nhận hàng': 'M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4 0v8m0 0l3-3m-3 3L9 9',
    'trả hàng': 'M3 10h10a5 5 0 015 5v6M3 10l6-6M3 10l6 6',
    'chi phí': 'M19 14l-7 7m0 0l-7-7m7 7V3',
    'mua sắm': 'M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z',
    'ghi tăng': 'M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z',
    'ghi giảm': 'M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z',
    'khấu hao': 'M13 17h8m0 0V9m0 8l-8-8-4 4-6-6',
    'nâng cấp': 'M5 10l7-7m0 0l7 7m-7-7v18',
    'định giá': 'M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z',
    'phân bổ': 'M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4',
    'chấm công': 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
    'chốt công': 'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z',
    'tính công': 'M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z',
    'lương': 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    'phụ cấp': 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    'thưởng phạt': 'M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z',
    'doanh thu': 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6',
    'lời lỗ': 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
    'hoa hồng': 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    'tiêu hao': 'M19 14l-7 7m0 0l-7-7m7 7V3',
    'cước vận tải': 'M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0',
    'ngân sách': 'M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4',
    'phê duyệt': 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
    'người dùng': 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z',
    'phân quyền': 'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z',
    'khởi tạo': 'M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12',
    'nạp tiền': 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    'dữ liệu': 'M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4',
    'kiểm tra': 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
    'sao lưu': 'M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4',
    'tài liệu': 'M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z',
    'kiến thức': 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z',
    'nguồn': 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
    'lệnh sản xuất': 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z',
    'kế hoạch': 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
    'định mức': 'M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z',
    'luân chuyển': 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15',
    'quy tắc': 'M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4',
    'incentive': 'M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z',
    'nhượng quyền': 'M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z',
    'catalog': 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
    'ánh xạ': 'M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4',
    'công việc': 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
    'cuộc họp': 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z',
    'phòng họp': 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
    'thư mục': 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z',
    'bảng tin': 'M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z',
    'mục tiêu': 'M13 10V3L4 14h7v7l9-11h-7z',
    'tỷ giá': 'M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4',
    'đánh giá lại': 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15',
    'điều phối': 'M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7',
    'vận đơn': 'M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0',
    'lịch sử': 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
    'bảo hành': 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
    'sửa chữa': 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z',
    'thu cũ': 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15',
    'bảo dưỡng': 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z',
    'đăng ký': 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
    'nhắc': 'M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9',
    'thẻ dịch vụ': 'M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z',
    'bán vé': 'M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z',
    'chuyến xe': 'M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0',
    'hành trình': 'M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7',
    'tích điểm': 'M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z',
    'sản phẩm': 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
    'biến thể': 'M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01',
    'gói trả trước': 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
};
var FALLBACK_ICON = 'M4 6h16M4 12h16M4 18h16'; // menu lines

function getItemIcon(item) {
    // 1. SVG file URL (webpack-imported asset): { kind: 'svgFile' }
    if (item.icon && typeof item.icon === 'string' && (item.icon.indexOf('/') >= 0 || item.icon.indexOf('.') >= 0 || item.icon.indexOf('data:') >= 0)) {
        return { kind: 'svgFile', value: item.icon };
    }
    // 2. SVG path data (raw "M..." string): { kind: 'svgPath' }
    if (item.icon && typeof item.icon === 'string' && item.icon.length > 8 && item.icon.charAt(0) === 'M' && item.icon.indexOf(' ') > 0) {
        return { kind: 'svgPath', value: item.icon };
    }
    // 3. DX icon shortname (e.g. 'cart', 'clock', 'undo', 'cut'): { kind: 'dx' }
    if (item.icon && typeof item.icon === 'string') {
        return { kind: 'dx', value: item.icon };
    }
    // 4. Keyword match against ITEM_ICON_MAP from path/text/hint
    var searchStr = ((item.path || '') + ' ' + (item.text || '') + ' ' + (item.hint || '')).toLowerCase();
    var keys = Object.keys(ITEM_ICON_MAP);
    for (var i = 0; i < keys.length; i++) {
        if (searchStr.indexOf(keys[i]) >= 0) return { kind: 'svgPath', value: ITEM_ICON_MAP[keys[i]] };
    }
    return { kind: 'svgPath', value: FALLBACK_ICON };
}

function renderItemIcon(iconInfo, className) {
    if (!iconInfo) return null;
    if (iconInfo.kind === 'svgFile') {
        return <img src={iconInfo.value} alt="" className={className || 'nav-v2-item-svg'} />;
    }
    if (iconInfo.kind === 'dx') {
        return <i className={'dx-icon dx-icon-' + iconInfo.value} />;
    }
    return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d={iconInfo.value} /></svg>;
}

// Khóa nhớ tab riêng theo không gian: Vận hành giữ khóa cũ, Kế toán thêm hậu tố — chuyển chế độ không mang tab
// của thực đơn này sang thực đơn kia (thực đơn không có tab đó thì cột trái trống).
function storageKeyOf(workspaceMode) {
    return STORAGE_KEY + (workspaceMode === 'Accounting' ? '_acc' : '');
}

function getStoredModule(workspaceMode) {
    try {
        return localStorage.getItem(storageKeyOf(workspaceMode)) || 'home';
    } catch (e) {
        return 'home';
    }
}

function setStoredModule(mod, workspaceMode) {
    try {
        localStorage.setItem(storageKeyOf(workspaceMode), mod);
    } catch (e) {
        // silent
    }
}

export default function (props) {
    var location = useLocation();
    var appGlobal = AntGlobal();
    var refContainer = useRef();
    var workspaceMode = appGlobal && appGlobal.workspaceMode;

    var items = props.items || [];
    var modules = props.modules || [];
    var menuOpened = props.menuOpened;

    // --- Detect active module from current route ---
    var detectModuleFromPath = useCallback(function (pathname) {
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.path && pathname.indexOf(item.path) === 0 && item.module) {
                return item.module;
            }
            if (item.items instanceof Array) {
                for (var j = 0; j < item.items.length; j++) {
                    var child = item.items[j];
                    if (child.path && pathname.indexOf(child.path) === 0 && (child.module || item.module)) {
                        return child.module || item.module;
                    }
                }
            }
        }
        return null;
    }, [items]);

    var [activeModule, setActiveModule] = useState(function () {
        var detected = detectModuleFromPath(window.location.pathname);
        return detected || getStoredModule(workspaceMode);
    });

    // --- Auto-detect module when route changes ---
    useEffect(function () {
        var detected = detectModuleFromPath(location.pathname);
        if (detected && detected !== activeModule) {
            setActiveModule(detected);
            setStoredModule(detected, workspaceMode);
            AntBadgeStore.invalidate();
        }
    }, [location.pathname]);

    // --- Filter visible modules (chỉ hiện module có ít nhất 1 item) ---
    var visibleModules = useMemo(function () {
        var itemModules = {};
        for (var i = 0; i < items.length; i++) {
            if (items[i].module) itemModules[items[i].module] = true;
        }
        return modules.filter(function (mod) { return itemModules[mod.key]; });
    }, [modules, items]);

    // Kế toán: tab đang nhớ không thuộc thực đơn đang dựng (vd lần đầu vào Kế toán) thì mở tab đầu tiên.
    // Vận hành giữ nguyên hành vi cũ.
    useEffect(function () {
        if (workspaceMode !== 'Accounting' || visibleModules.length === 0) return;
        var found = visibleModules.some(function (mod) { return mod.key === activeModule; });
        if (!found) setActiveModule(visibleModules[0].key);
    }, [visibleModules, activeModule]);

    // --- Sub-group labels ---
    // Key 'sell' = section đầu, không có header label.
    // distinctable=true: nếu subGroup chỉ có 1 item, ẩn header và render item flat ở root.
    var SUB_GROUPS = {
        sell:           { label: null,                                                       distinctable: false },
        fulfill:        { label: { vi: 'Thực hiện', en: 'Fulfillment', fr: 'Exécution', es: 'Cumplimiento', id: 'Pemenuhan', ja: '履行', zh: '履约', ko: '이행', hi: 'पूर्ति', ar: 'التنفيذ' },                     distinctable: true },
        warranty:       { label: { vi: 'Bảo hành & Sửa chữa', en: 'Warranty & Repair', fr: 'Garantie & réparation', es: 'Garantía y reparación', id: 'Garansi & Perbaikan', ja: '保証・修理', zh: '保修与维修', ko: '보증 및 수리', hi: 'वारंटी व मरम्मत', ar: 'الضمان والإصلاح' },     distinctable: true },
        crm:            { label: { vi: 'Khách hàng', en: 'Customers', fr: 'Clients', es: 'Clientes', id: 'Pelanggan', ja: '顧客', zh: '客户', ko: '고객', hi: 'ग्राहक', ar: 'العملاء' },                      distinctable: true },
        omni_sell:      { label: { vi: 'Bán hàng', en: 'Sales', fr: 'Ventes', es: 'Ventas', id: 'Penjualan', ja: '販売', zh: '销售', ko: '판매', hi: 'बिक्री', ar: 'المبيعات' },                            distinctable: true },
        omni_monitor:   { label: { vi: 'Giám sát', en: 'Monitoring', fr: 'Suivi', es: 'Monitoreo', id: 'Pemantauan', ja: 'モニタリング', zh: '监控', ko: '모니터링', hi: 'निगरानी', ar: 'المراقبة' },                       distinctable: true },
        omni_config:    { label: { vi: 'Cấu hình', en: 'Configuration', fr: 'Configuration', es: 'Configuración', id: 'Konfigurasi', ja: '設定', zh: '配置', ko: '설정', hi: 'कॉन्फ़िगरेशन', ar: 'الإعدادات' },                    distinctable: true },
        social_ops:     { label: { vi: 'Nghiệp vụ', en: 'Operations', fr: 'Opérations', es: 'Operaciones', id: 'Operasional', ja: '業務', zh: '业务', ko: '업무', hi: 'संचालन', ar: 'العمليات' },                      distinctable: true },
        social_monitor: { label: { vi: 'Giám sát', en: 'Monitoring', fr: 'Suivi', es: 'Monitoreo', id: 'Pemantauan', ja: 'モニタリング', zh: '监控', ko: '모니터링', hi: 'निगरानी', ar: 'المراقبة' },                       distinctable: true },
        social_config:  { label: { vi: 'Cấu hình', en: 'Configuration', fr: 'Configuration', es: 'Configuración', id: 'Konfigurasi', ja: '設定', zh: '配置', ko: '설정', hi: 'कॉन्फ़िगरेशन', ar: 'الإعدادات' },                    distinctable: true },
        gl_posting:     { label: { vi: 'Hạch toán tự động', en: 'Auto Posting', fr: 'Écritures auto', es: 'Asientos auto.', id: 'Posting otomatis', ja: '自動仕訳', zh: '自动记账', ko: '자동 분개', hi: 'स्वचालित लेखांकन', ar: 'الترحيل التلقائي' },             distinctable: true },
        gl_accounting:  { label: { vi: 'Kế toán', en: 'Accounting', fr: 'Comptabilité', es: 'Contabilidad', id: 'Akuntansi', ja: '会計', zh: '会计', ko: '회계', hi: 'लेखांकन', ar: 'المحاسبة' },                        distinctable: true },
        gl_report:      { label: { vi: 'Báo cáo tài chính', en: 'Financial Reports', fr: 'États financiers', es: 'Estados financieros', id: 'Laporan keuangan', ja: '財務諸表', zh: '财务报表', ko: '재무제표', hi: 'वित्तीय विवरण', ar: 'القوائم المالية' },       distinctable: true },
        setting_connection: { label: { vi: 'Kết Nối', en: 'Connections', fr: 'Connexions', es: 'Conexiones', id: 'Koneksi', ja: '連携', zh: '连接', ko: '연결', hi: 'कनेक्शन', ar: 'الاتصالات' }, distinctable: true },
        setting_permission: { label: { vi: 'Phân Quyền', en: 'Permission', fr: 'Autorisations', es: 'Permiso', id: 'Izin', ja: '権限', zh: '权限', ko: '권한', hi: 'अनुमति', ar: 'الإذن' }, distinctable: true },
        setting_system:     { label: { vi: 'Hệ thống', en: 'System', fr: 'Système', es: 'Sistema', id: 'Sistem', ja: 'システム', zh: '系统', ko: '시스템', hi: 'सिस्टम', ar: 'النظام' }, distinctable: true },
        // Module 'connect' — theo dõi/đối soát kết nối với providers (sale/social/...).
        connect_sale_monitor:   { label: { vi: 'Sàn TMĐT', en: 'Marketplaces', fr: 'Marketplaces', es: 'Marketplaces', id: 'E-commerce', ja: 'ECモール', zh: '电商', ko: '판매 채널', hi: 'मार्केटप्लेस', ar: 'قنوات البيع' }, distinctable: true },
        connect_social_monitor: { label: { vi: 'Mạng xã hội', en: 'Social', fr: 'Social', es: 'Social', id: 'Sosial', ja: 'ソーシャル', zh: '社交', ko: '소셜', hi: 'सोशल', ar: 'وسائل التواصل' }, distinctable: true },
        connect_message:   { label: { vi: 'Email & SMS', en: 'Email & SMS', fr: 'Email & SMS', es: 'Email y SMS', id: 'Email & SMS', ja: 'メール・SMS', zh: '邮件短信', ko: '이메일·SMS', hi: 'ईमेल और SMS', ar: 'البريد والرسائل' }, distinctable: true },
        connect_advertise: { label: { vi: 'Quảng cáo', en: 'Advertising', fr: 'Publicité', es: 'Publicidad', id: 'Iklan', ja: '広告', zh: '广告', ko: '광고', hi: 'विज्ञापन', ar: 'الإعلانات' }, distinctable: true },
        connect_review:    { label: { vi: 'Đánh giá', en: 'Reviews', fr: 'Avis', es: 'Reseñas', id: 'Ulasan', ja: 'レビュー', zh: '评价', ko: '리뷰', hi: 'समीक्षाएं', ar: 'التقييمات' }, distinctable: true },
        connect_affiliate: { label: { vi: 'Affiliate', en: 'Affiliate', fr: 'Affiliation', es: 'Afiliados', id: 'Afiliasi', ja: 'アフィリエイト', zh: '联盟营销', ko: '제휴', hi: 'सहबद्ध', ar: 'التسويق بالعمولة' }, distinctable: true },
        connect_carrier:   { label: { vi: 'Vận chuyển', en: 'Carriers', fr: 'Transporteurs', es: 'Transportistas', id: 'Pengiriman', ja: '配送業者', zh: '物流商', ko: '배송업체', hi: 'कूरियर', ar: 'شركات الشحن' }, distinctable: true },
        connect_food:      { label: { vi: 'Giao đồ ăn', en: 'Food Delivery', fr: 'Livraison repas', es: 'Entrega de comida', id: 'Antar makanan', ja: 'フードデリバリー', zh: '外卖配送', ko: '음식 배달', hi: 'फूड डिलीवरी', ar: 'توصيل الطعام' }, distinctable: true }
    };
    // Thứ tự section trong từng tab (module). Tab Settings: sell (Cấu hình chung) →
    // setting_connection (Kết Nối) → setting_permission (Phân Quyền) → các bucket khác →
    // setting_system (Hệ thống — LUÔN CUỐI CÙNG).
    // Tab Connect: sell (general) → connect_sale_monitor → connect_social_monitor → các bucket khác.
    var SUB_GROUP_ORDER = ['sell', 'setting_connection', 'setting_permission', 'connect_sale_monitor', 'connect_social_monitor', 'connect_message', 'connect_advertise', 'connect_review', 'connect_affiliate', 'connect_carrier', 'connect_food', 'fulfill', 'warranty', 'crm', 'omni_sell', 'omni_monitor', 'omni_config', 'social_ops', 'social_monitor', 'social_config', 'gl_posting', 'gl_accounting', 'gl_report', 'setting_system'];

    // --- Items của module đang active, đã sort theo subGroup -----------------
    // Entry = { _type:'item', item, subGroup } hoặc { _type:'group', text, icon, subGroup, children }
    var filteredItems = useMemo(function () {
        var entries = [];

        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.module !== activeModule) continue;

            var translated = Object.assign({}, item);
            translated.text = AntLocalization.translateText(AntCondition.getValue({}, item.text));
            translated.hint = translated.text;

            if (item.items instanceof Array && item.items.length > 0) {
                var children = [];
                for (var j = 0; j < item.items.length; j++) {
                    var child = item.items[j];
                    var tc = Object.assign({}, child);
                    tc.text = AntLocalization.translateText(AntCondition.getValue({}, child.text));
                    tc.hint = tc.text;
                    children.push(tc);
                }
                entries.push({ _type: 'group', text: translated.text, icon: translated.icon, subGroup: translated.subGroup, children: children });
            } else {
                entries.push({ _type: 'item', item: translated, subGroup: translated.subGroup });
            }
        }

        // Stable sort: group theo SUB_GROUP_ORDER; subGroup lạ gom vào 'sell'.
        // Normalise entries[].subGroup để render section không bị split.
        var buckets = {};
        for (var s = 0; s < SUB_GROUP_ORDER.length; s++) buckets[SUB_GROUP_ORDER[s]] = [];
        for (var r = 0; r < entries.length; r++) {
            var sg = entries[r].subGroup;
            if (!sg || !buckets[sg]) sg = 'sell';
            entries[r].subGroup = sg;
            buckets[sg].push(entries[r]);
        }
        var sorted = [];
        for (var t = 0; t < SUB_GROUP_ORDER.length; t++) {
            var b = buckets[SUB_GROUP_ORDER[t]];
            for (var u = 0; u < b.length; u++) sorted.push(b[u]);
        }
        return sorted;
    }, [items, activeModule]);

    // --- Active item based on route ---
    var activeItemPath = useMemo(function () {
        var bestMatch = null;
        var bestLen = 0;
        var checkPath = function (path) {
            if (path && location.pathname.indexOf(path) === 0 && path.length > bestLen) {
                bestMatch = path; bestLen = path.length;
            }
        };
        for (var i = 0; i < filteredItems.length; i++) {
            var entry = filteredItems[i];
            if (entry._type === 'item') {
                checkPath(entry.item.path);
            } else if (entry._type === 'group' && entry.children) {
                for (var j = 0; j < entry.children.length; j++) {
                    checkPath(entry.children[j].path);
                }
            }
        }
        return bestMatch;
    }, [filteredItems, location.pathname]);

    // --- Expanded groups (tree) ---
    var [expandedGroups, setExpandedGroups] = useState({});

    var toggleGroup = useCallback(function (groupText) {
        setExpandedGroups(function (prev) {
            var n = Object.assign({}, prev);
            n[groupText] = !n[groupText];
            return n;
        });
    }, []);

    // Auto-expand group containing active item
    useEffect(function () {
        for (var i = 0; i < filteredItems.length; i++) {
            var entry = filteredItems[i];
            if (entry._type === 'group' && entry.children) {
                for (var j = 0; j < entry.children.length; j++) {
                    if (entry.children[j].path === activeItemPath) {
                        setExpandedGroups(function (prev) {
                            var n = Object.assign({}, prev);
                            n[entry.text] = true;
                            return n;
                        });
                        break;
                    }
                }
            }
        }
    }, [activeItemPath]);

    // --- Module tab click ---
    var onModuleClick = useCallback(function (mod) {
        var moduleKey = mod && mod.key ? mod.key : mod;
        // Đổi module (kể cả khi KHÔNG điều hướng route, xem comment dưới) → badge phải refetch ngay,
        // không đợi route đổi vì phần lớn module KHÔNG đổi URL khi bấm tab.
        if (moduleKey !== activeModule) AntBadgeStore.invalidate();
        setActiveModule(moduleKey);
        setStoredModule(moduleKey, workspaceMode);
        if (props.onModuleChanged) props.onModuleChanged(moduleKey);
        // Tạm thời ẩn module-home: chỉ 'home' điều hướng (→ /home dashboards).
        // Mọi module khác (kể cả 'ar' bán hàng): chỉ đổi active tab, KHÔNG mở module home page.
        var ALLOW_MODULE_HOME = ['home'];
        if (props.onSelectionChanged && ALLOW_MODULE_HOME.indexOf(moduleKey) !== -1) {
            var path = (mod && mod.path) ? mod.path : ('/module/' + moduleKey);
            props.onSelectionChanged({ itemData: { path: path } });
        } else if (props.onSelectionChanged && !props.menuOpened) {
            // Drawer đang thu gọn (minimize) → bấm module icon thì BUNG drawer (không điều hướng).
            props.onSelectionChanged({ itemData: {} });
        }
    }, [props.onModuleChanged, props.onSelectionChanged, props.menuOpened, activeModule]);

    // --- Nav item click ---
    var onItemClick = useCallback(function (item) {
        if (props.onSelectionChanged) {
            props.onSelectionChanged({ itemData: item });
        }
    }, [props.onSelectionChanged]);

    // --- Exit / Log out ---
    var onExitClick = useCallback(function () {
        AntAuth.logOut();
    }, []);

    // --- Tooltip (collapsed mode) ---
    var [menuTip, setMenuTip] = useState(null);

    var onMouseOverItem = useCallback(function (e, text) {
        if (refContainer.current && refContainer.current.offsetWidth > 50) {
            setMenuTip(null);
            return;
        }
        if (!text) { setMenuTip(null); return; }
        var r = e.currentTarget.getBoundingClientRect();
        setMenuTip({ text: text, left: r.right + 6, top: r.top + r.height / 2 });
    }, []);

    var onMouseOutItem = useCallback(function () {
        setMenuTip(null);
    }, []);

    // --- Module area height (persisted) ---
    var MOD_STORAGE_KEY = 'ant_nav_v2_mod_h';
    var MOD_DEFAULT_H = 250;
    var MOD_MIN_H = 100;

    var savedH = MOD_DEFAULT_H;
    try { var parsed = parseInt(localStorage.getItem(MOD_STORAGE_KEY), 10); if (parsed >= MOD_MIN_H) savedH = parsed; } catch (e) { /* */ }

    var [modHeight, setModHeight] = useState(savedH);
    var modHeightRef = useRef(savedH);
    var resizingRef = useRef(false);
    var startYRef = useRef(0);
    var startHRef = useRef(0);

    // Persist whenever modHeight changes
    useEffect(function () {
        modHeightRef.current = modHeight;
        try { localStorage.setItem(MOD_STORAGE_KEY, String(Math.round(modHeight))); } catch (e) { /* */ }
    }, [modHeight]);

    var onResizeStart = useCallback(function (e) {
        e.preventDefault();
        resizingRef.current = true;
        startYRef.current = e.clientY;
        startHRef.current = modHeightRef.current;
        var onMove = function (ev) {
            if (!resizingRef.current) return;
            var delta = startYRef.current - ev.clientY;
            var newH = Math.max(MOD_MIN_H, startHRef.current + delta);
            setModHeight(newH);
        };
        var onUp = function () {
            resizingRef.current = false;
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
        };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
    }, []);

    // --- onMenuReady ---
    useEffect(function () {
        if (props.onMenuReady) props.onMenuReady({});
    }, []);

    // --- Nav Badges: số phiếu cần xử lý ---
    var [badges, setBadges] = useState({});

    var badgeTasks = useMemo(function () {
        var tasks = [];
        var seen = {};
        var push = function (it) {
            if (!it || !it.navBadge || it.visible === false) return;
            // Khoá = path: BE đếm và trả theo path của badgeRegistry.
            var key = it.path;
            if (!key || seen[key]) return;
            seen[key] = true;
            tasks.push({ key: key, navBadge: it.navBadge });
        };
        for (var i = 0; i < items.length; i++) {
            var it = items[i];
            push(it);
            if (it.items instanceof Array) {
                for (var j = 0; j < it.items.length; j++) push(it.items[j]);
            }
        }
        return tasks;
    }, [items]);

    useEffect(function () {
        if (!badgeTasks.length) { setBadges({}); return; }
        var SG = appGlobal && appGlobal.appConfig && appGlobal.appConfig.SearchGroups;

        var resolveConditions = function (navBadge) {
            if (!navBadge || !navBadge.table) return null;
            if (navBadge.searchConditions) return navBadge.searchConditions;
            if (!SG || !navBadge.searchGroup) return null;
            var entry = SG.find ? SG.find(function (g) { return g.name === navBadge.table; }) : null;
            var groups = entry && entry.value;
            if (!(groups instanceof Array)) return null;
            var grp = groups.find(function (g) { return g.name === navBadge.searchGroup; });
            return grp && grp.searchConditions ? grp.searchConditions : null;
        };

        var registerItems = [];
        var registerKeys = [];
        for (var i = 0; i < badgeTasks.length; i++) {
            var task = badgeTasks[i];
            var conds = resolveConditions(task.navBadge);
            if (!conds) continue;
            registerItems.push({
                key: task.key,
                module: task.navBadge.module,
                table: task.navBadge.table,
                searchConditions: conds
            });
            registerKeys.push(task.key);
        }
        if (registerItems.length === 0) { setBadges({}); return; }
        AntBadgeStore.registerItems(registerItems);

        var unsubscribe = AntBadgeStore.subscribe(function (snapshot) {
            var next = {};
            for (var k = 0; k < registerKeys.length; k++) {
                var key = registerKeys[k];
                next[key] = (snapshot && snapshot.counts && snapshot.counts[key]) || 0;
            }
            setBadges(next);
        });

        return function () {
            unsubscribe();
            AntBadgeStore.unregisterItems(registerKeys);
        };
    }, [badgeTasks]);

    var renderBadge = function (item) {
        if (!item || !item.navBadge) return null;
        var n = item.path && badges[item.path];
        if (!n || n <= 0) return null;
        return <span className="nav-v2-item-badge">{n > 99 ? '99+' : n}</span>;
    };

    // --- Exit button label ---
    var exitText = useMemo(function () {
        return AntLocalization.translateText({
            vi: 'Đăng Xuất',
            en: 'Log Out',
            fr: 'Déconnexion',
            es: 'Salir',
            id: 'Keluar',
            ja: 'ログアウト',
            zh: '退出登录',
            ko: '로그아웃',
            hi: 'लॉग आउट',
            ar: 'تسجيل الخروج'
        });
    }, []);

    // ═══════════════════════════════════════════════════════════
    // --- Switch Store subView (mirror AntMainHeader/AntSwitchStore data + switch logic;
    //     chỉ khác cách hiển thị: thay nội dung cả khung thay vì dropdown nổi) ---
    // ═══════════════════════════════════════════════════════════
    var [subView, setSubView] = useState('nav'); // 'nav' | 'storeList'
    var [stores, setStores] = useState([]);
    var storesQueriedRef = useRef(false);

    var allStoresText = useMemo(function () {
        return AntLocalization.translateText({ vi: 'Tất cả cửa hàng', en: 'All Stores', fr: 'Tous les magasins', es: 'Todas las tiendas', id: 'Semua Toko', ja: '全店舗', zh: '所有门店', ko: '전체 매장', hi: 'सभी स्टोर', ar: 'جميع المتاجر' });
    }, []);

    var backText = useMemo(function () {
        return AntLocalization.translateText({ vi: 'Quay lại', en: 'Back', fr: 'Retour', es: 'Atrás', id: 'Kembali', ja: '戻る', zh: '返回', ko: '뒤로', hi: 'वापस', ar: 'رجوع' });
    }, []);

    useEffect(function () {
        var storeAPI = new AntAPI('user', 'ACUserAuthen', []);
        storeAPI.getList({}, storeAPI.routeURL + '/switchableStores').then(function (result) {
            if (result && result.rows instanceof Array) {
                var ar = [{ store_code: 'ALL_STORES', store_name: 'ALL_STORES', text: allStoresText, addressText: '' }];
                ar.push.apply(ar, result.rows.map(function (r) {
                    // Cùng thứ tự/quy ước join address với cột "Địa chỉ" ở Stores1 (address, adm3, adm2, adm1).
                    var addrParts = [r.address, r.adm3_name, r.adm2_name, r.adm1_name].filter(function (v) { return Boolean(v); });
                    return { store_code: r.code, store_name: r.name, text: r.name, addressText: addrParts.join(', ') };
                }));
                storesQueriedRef.current = true;
                setStores(ar);
            }
        });
    }, [allStoresText]);

    var onStoreClick = useCallback(function (store) {
        AntAuth.switchStore(store.store_code, function () {
            for (var i = 0; i < localStorage.length; i++) {
                var key = localStorage.key(i);
                if (key.startsWith(cs.System_Code + '-search-prepare-')) localStorage.removeItem(key);
            }
            setSubView('nav');
        });
    }, []);

    var onSwitchStoreTriggerClick = useCallback(function () {
        setSubView('storeList');
        if (!props.menuOpened && props.onSelectionChanged) props.onSelectionChanged({ itemData: {} }); // drawer thu gọn → bung ra để thấy danh sách
    }, [props.menuOpened, props.onSelectionChanged]);

    var currentStoreCode = AntAuth.getSessionInfo('store_code') || 'ALL_STORES';
    var showSwitchStoreTrigger = storesQueriedRef.current && stores.length > 2;

    // Label nút hiện GIÁ TRỊ đang chọn (tên + địa chỉ cửa hàng hiện tại) — giống filter, không phải nhãn hành động tĩnh.
    var currentStore = useMemo(function () {
        var found = stores.find(function (s) { return s.store_code === currentStoreCode; });
        return found || { text: allStoresText, addressText: '' };
    }, [stores, currentStoreCode, allStoresText]);
    var currentStoreName = currentStore.text;
    var currentStoreAddress = currentStore.addressText;

    return (
        <div className={'ant-nav-v2' + (menuOpened ? ' expanded' : ' collapsed')} ref={refContainer}>
            {props.children}

            {/* ── Nút thu gọn / mở rộng drawer ── */}
            {props.toggleMenu && (
                <div className="nav-v2-toggle" onClick={props.toggleMenu}
                    title={AntLocalization.translateText(menuOpened ? { vi: 'Thu gọn', en: 'Collapse', fr: 'Réduire', es: 'Contraer', id: 'Ciutkan', ja: '折りたたむ', zh: '收起', ko: '접기', hi: 'समेटें', ar: 'طي' } : { vi: 'Mở rộng', en: 'Expand', fr: 'Développer', es: 'Expandir', id: 'Perluas', ja: '展開', zh: '展开', ko: '펼치기', hi: 'फैलाएँ', ar: 'توسيع' })}>
                    <span className="nav-v2-toggle-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d={menuOpened ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6'} />
                        </svg>
                    </span>
                </div>
            )}

            {subView === 'nav' && (
            <React.Fragment>
            {/* ── Items Area ── */}
            <div className="nav-v2-items">
                {(function () {
                    // Group filtered items by subGroup for unified rendering
                    var groups = [];
                    var currentSG = null;
                    var currentItems = [];
                    for (var fi = 0; fi < filteredItems.length; fi++) {
                        var sg = filteredItems[fi].subGroup || 'sell';
                        if (sg !== currentSG) {
                            if (currentItems.length > 0) groups.push({ sg: currentSG, items: currentItems });
                            currentSG = sg;
                            currentItems = [];
                        }
                        currentItems.push(filteredItems[fi]);
                    }
                    if (currentItems.length > 0) groups.push({ sg: currentSG, items: currentItems });

                    var onlyOneGroup = groups.length === 1;
                    // Đếm tổng số nested group (_type==='group') trong cả module — nếu chỉ có 1 thì flatten
                    var totalNestedGroups = 0;
                    for (var gci = 0; gci < groups.length; gci++) {
                        for (var gcj = 0; gcj < groups[gci].items.length; gcj++) {
                            if (groups[gci].items[gcj]._type === 'group') totalNestedGroups++;
                        }
                    }
                    var flattenSingleGroup = totalNestedGroups === 1;
                    return groups.map(function (grp, gi) {
                        var sgMeta = SUB_GROUPS[grp.sg] || {};
                        var sgLabel = sgMeta.label;
                        var isFirst = gi === 0;
                        var sgKey = 'sg-' + grp.sg;
                        // Flatten: subGroup có distinctable=true và chỉ chứa đúng 1 item → ẩn header, render flat
                        var canFlattenSubGroup = !!sgMeta.distinctable && grp.items.length === 1;
                        var isSGOpen = (onlyOneGroup || canFlattenSubGroup) ? true : (expandedGroups[sgKey] !== false);
                        var sgHasActive = grp.items.some(function (e) {
                            if (e._type === 'item') return e.item.path === activeItemPath;
                            if (e._type === 'group') return e.children.some(function (c) { return c.path === activeItemPath; });
                            return false;
                        });

                        // Render header (skip for first group, when module has only 1 subgroup, when label null, or when flattened)
                        var header = null;
                        if (!onlyOneGroup && !canFlattenSubGroup && sgLabel !== null && sgLabel !== undefined) {
                            header = (
                                <div className={'nav-v2-subgroup-sep nav-v2-subgroup-toggle' + (sgHasActive && !isSGOpen ? ' has-active' : '')}
                                    onClick={function () { setExpandedGroups(function (prev) { var n = Object.assign({}, prev); n[sgKey] = !isSGOpen; return n; }); }}>
                                    <span className="nav-v2-subgroup-label">{AntLocalization.translateText(sgLabel)}</span>
                                    {menuOpened && <span className={'nav-v2-group-arrow' + (isSGOpen ? ' open' : '')}><svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M6 9l6 6 6-6" /></svg></span>}
                                </div>
                            );
                        }

                        if (!isSGOpen) return <React.Fragment key={gi}>{header}</React.Fragment>;

                        // Render items
                        var itemEls = grp.items.map(function (entry, idx) {
                            // ── GROUP (collapsible tree) ──
                            if (entry._type === 'group') {
                                // Nếu cả module chỉ có đúng 1 nested group → render flat (bỏ header toggle)
                                if (flattenSingleGroup) {
                                    return (
                                        <React.Fragment key={'g-' + idx}>
                                            {entry.children.map(function (child, ci) {
                                                var isChildActive2 = child.path === activeItemPath;
                                                var childIcon2 = getItemIcon(child);
                                                return (
                                                    <div key={child.path || ci} className={'nav-v2-item' + (isChildActive2 ? ' active' : '')}
                                                        onClick={function () { onItemClick(child); }}
                                                        onMouseOver={function (e) { onMouseOverItem(e, child.hint || child.text); }} onMouseOut={onMouseOutItem}
                                                        title={menuOpened ? '' : (child.hint || child.text)}>
                                                        <span className="nav-v2-item-icon">{renderItemIcon(childIcon2)}</span>
                                                        {menuOpened && <span className="nav-v2-item-text">{child.text}</span>}
                                                        {menuOpened && renderBadge(child)}
                                                    </div>
                                                );
                                            })}
                                        </React.Fragment>
                                    );
                                }
                                var groupKey = 'grp-' + entry.text;
                                var isGroupOpen = expandedGroups[groupKey] !== false;
                                var groupHasActive = entry.children.some(function (c) { return c.path === activeItemPath; });
                                return (
                                    <div key={'g-' + idx} className="nav-v2-group">
                                        <div className={'nav-v2-subgroup-sep nav-v2-subgroup-toggle nav-v2-subgroup-inline' + (groupHasActive && !isGroupOpen ? ' has-active' : '')}
                                            onClick={function () { setExpandedGroups(function (prev) { var n = Object.assign({}, prev); n[groupKey] = !isGroupOpen; return n; }); }}>
                                            <span className="nav-v2-subgroup-label">{entry.text}</span>
                                            {menuOpened && <span className={'nav-v2-group-arrow' + (isGroupOpen ? ' open' : '')}><svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M6 9l6 6 6-6" /></svg></span>}
                                        </div>
                                        {isGroupOpen && entry.children.map(function (child, ci) {
                                            var isChildActive = child.path === activeItemPath;
                                            var childIcon = getItemIcon(child);
                                            return (
                                                <div key={child.path || ci} className={'nav-v2-item' + (isChildActive ? ' active' : '')}
                                                    onClick={function () { onItemClick(child); }}
                                                    onMouseOver={function (e) { onMouseOverItem(e, child.hint || child.text); }} onMouseOut={onMouseOutItem}
                                                    title={menuOpened ? '' : (child.hint || child.text)}>
                                                    <span className="nav-v2-item-icon">{renderItemIcon(childIcon)}</span>
                                                    {menuOpened && <span className="nav-v2-item-text">{child.text}</span>}
                                                    {menuOpened && renderBadge(child)}
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            }
                            // ── FLAT ITEM ──
                            var item = entry.item;
                            var isActive = item.path && item.path === activeItemPath;
                            var svgPath = getItemIcon(item);
                            return (
                                <div key={item.path || item.name || idx} className={'nav-v2-item' + (isActive ? ' active' : '')}
                                    onClick={function () { onItemClick(item); }}
                                    onMouseOver={function (e) { onMouseOverItem(e, item.hint || item.text); }} onMouseOut={onMouseOutItem}
                                    title={menuOpened ? '' : (item.hint || item.text)}>
                                    <span className="nav-v2-item-icon">{renderItemIcon(svgPath)}</span>
                                    {menuOpened && <span className="nav-v2-item-text">{item.text}</span>}
                                    {menuOpened && renderBadge(item)}
                                </div>
                            );
                        });

                        return <React.Fragment key={gi}>{header}{itemEls}</React.Fragment>;
                    });
                })()}
            </div>

            {/* ── Resizer ── */}
            {menuOpened && (
                <div className="nav-v2-resizer" onMouseDown={onResizeStart} />
            )}

            {/* ── Module Tabs ── */}
            <div className={'nav-v2-modules' + (menuOpened ? '' : ' collapsed')} style={menuOpened ? { height: modHeight } : undefined}>
                {visibleModules.map(function (mod) {
                    var isActive = mod.key === activeModule;
                    var label = AntLocalization.translateText(AntCondition.getValue({}, mod.text || mod.label || {}));
                    return (
                        <div
                            key={mod.key}
                            className={'nav-v2-module-tab' + (isActive ? ' active' : '')}
                            onClick={function () { onModuleClick(mod); }}
                            onMouseOver={function (e) { onMouseOverItem(e, label); }}
                            onMouseOut={onMouseOutItem}
                            title={menuOpened ? '' : label}
                        >
                            <span className="nav-v2-module-icon">
                                {mod.icon ? (
                                    typeof mod.icon === 'string' && mod.icon.indexOf('M') >= 0
                                        ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d={mod.icon} /></svg>
                                        : typeof mod.icon === 'string' && (mod.icon.indexOf('/') >= 0 || mod.icon.indexOf('.') >= 0)
                                            ? <img src={mod.icon} alt="" className="nav-v2-module-svg" />
                                            : <i className={'dx-icon dx-icon-' + mod.icon} />
                                ) : (
                                    <span className="nav-v2-module-icon-fallback">{(mod.key || '?').charAt(0).toUpperCase()}</span>
                                )}
                            </span>
                            <span className="nav-v2-module-label">{label}</span>
                        </div>
                    );
                })}

                {/* ── Exit Button ── */}
                <div
                    className="nav-v2-exit"
                    onClick={onExitClick}
                    onMouseOver={function (e) { onMouseOverItem(e, exitText); }}
                    onMouseOut={onMouseOutItem}
                    title={menuOpened ? '' : exitText}
                >
                    <span className="nav-v2-module-icon">
                        <i className="dx-icon dx-icon-runner" />
                    </span>
                    <span className="nav-v2-module-label">{exitText}</span>
                </div>
            </div>
            </React.Fragment>
            )}

            {/* ── Nút Đổi cửa hàng (bên dưới nav-v2-modules) — chỉ hiện khi có >=2 cửa hàng ── */}
            {subView === 'nav' && showSwitchStoreTrigger && (
                <div
                    className="nav-v2-switchstore-trigger"
                    onClick={onSwitchStoreTriggerClick}
                    onMouseOver={function (e) { onMouseOverItem(e, currentStoreName); }}
                    onMouseOut={onMouseOutItem}
                    title={menuOpened ? '' : (currentStoreAddress ? currentStoreName + '\n' + currentStoreAddress : currentStoreName)}
                >
                    <span className="nav-v2-switchstore-trigger-top">
                        <span className="nav-v2-switchstore-trigger-icon"><FaLocationDot /></span>
                        {menuOpened && <span className="nav-v2-switchstore-trigger-name">{currentStoreName}</span>}
                    </span>
                    {menuOpened && currentStoreAddress && <span className="nav-v2-switchstore-trigger-address">{currentStoreAddress}</span>}
                </div>
            )}

            {/* ── SubView: Danh sách cửa hàng (thay thế items+resizer+modules) ── */}
            {subView === 'storeList' && (
                <div className="nav-v2-storeswitch">
                    <div className="nav-v2-storeswitch-back" onClick={function () { setSubView('nav'); }}>
                        <span className="nav-v2-module-icon">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
                        </span>
                        {menuOpened && <span className="nav-v2-module-label">{backText}</span>}
                    </div>
                    <div className="nav-v2-storeswitch-list">
                        {stores.map(function (s) {
                            var isActive = s.store_code === currentStoreCode;
                            return (
                                <div key={s.store_code} className={'nav-v2-storeswitch-card' + (isActive ? ' active' : '')}
                                    onClick={function () { onStoreClick(s); }}>
                                    <span className="nav-v2-storeswitch-card-icon"><FaLocationDot /></span>
                                    <span className="nav-v2-storeswitch-card-body">
                                        <span className="nav-v2-storeswitch-card-name">{s.text}</span>
                                        {s.addressText && <span className="nav-v2-storeswitch-card-address">{s.addressText}</span>}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {/* ── Tooltip Portal (collapsed mode) ── */}
            {menuTip && ReactDOM.createPortal(
                <div style={{
                    position: 'fixed',
                    left: menuTip.left,
                    top: menuTip.top,
                    transform: 'translateY(-50%)',
                    padding: '5px 10px',
                    background: '#1a3561',
                    color: '#fff',
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                    borderRadius: '4px',
                    zIndex: 99999,
                    pointerEvents: 'none',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                }}>{menuTip.text}</div>,
                document.body
            )}
        </div>
    );
}
